/* eslint-disable global-require,@typescript-eslint/no-var-requires */

const COVER: string = require('@/assets/images/homescapes/cover.webp');

const TRAILERS: Record<string, string> = {
  ru: require('@/assets/videos/homescapes/trailer/ru.mp4'),
  en: require('@/assets/videos/homescapes/trailer/en.mp4'),
};

export { COVER, TRAILERS };
